import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, InputNumber, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useInputAndInput } from './_hooks/useInputAndInput';
import { fieldsUnitTexts } from './utils/FieldsUnitTexts';
import { ConditionCard } from '../../ConditionCard';
import { Text } from '@/components/Typography';
import { AditionalItemProps } from './types';
import { InfoList } from './InfoList';

const { formatPlaceholderWithUnit } = fieldsUnitTexts;

export function InputAndInput({ additionalItem }: Readonly<AditionalItemProps>): JSX.Element {
	const { id, title_1, title_2, unit_1, unit_2 } = additionalItem;

	const {
		formFieldName,
		localAdditionalItem,
		worstRisk,
		isAddDisabled,
		isCalculatingScore,
		handleAddAdditionalItemValueClick,
		handleRemoveAdditionalItemClick
	} = useInputAndInput({ additionalItem });

	return (
		<Row gutter={[0, 15]} key={id}>
			<Col span={24}>
				<Row align="bottom" gutter={[14, 20]}>
					<Col sm={24} lg={18}>
						<Row gutter={[0, 20]}>
							<Col span={24}>
								<Row gutter={[0, 5]}>
									<Col span={24}>
										<Text strong>{I18n.get(title_1)}</Text>
									</Col>
									<Col span={24}>
										<Form.Item
											style={{ margin: 0 }}
											name={[...formFieldName, 'additional_items', id, 'value_1']}
										>
											<InputNumber
												min={0}
												style={{ width: '100%' }}
												placeholder={formatPlaceholderWithUnit('0', unit_1)}
											/>
										</Form.Item>
									</Col>
								</Row>
							</Col>
							<Col span={24}>
								<Row gutter={[0, 5]}>
									<Col span={24}>
										<Text strong>{I18n.get(title_2)}</Text>
									</Col>
									<Col span={24}>
										<Form.Item
											style={{ margin: 0 }}
											name={[...formFieldName, 'additional_items', id, 'value_2']}
										>
											<InputNumber
												min={0}
												style={{ width: '100%' }}
												placeholder={formatPlaceholderWithUnit('0', unit_2)}
											/>
										</Form.Item>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
					<Col>
						<Button
							shape="circle"
							type="primary"
							icon={<PlusOutlined />}
							onClick={handleAddAdditionalItemValueClick}
							disabled={isAddDisabled}
						/>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<InfoList items={localAdditionalItem} onDeleteValue={handleRemoveAdditionalItemClick} />
			</Col>
			<Col span={24}>
				<ConditionCard result={worstRisk} isLoading={isCalculatingScore} />
			</Col>
		</Row>
	);
}
